import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { UserDigitalTutorSurveyControllerApi } from '../sdk-api/api/userDigitalTutorSurveyController.service';
import { ClinicalCase } from '../sdk-api/model/clinicalCase';
import { ClinicalCaseDigitalTutorWithRelations } from '../sdk-api/model/clinicalCaseDigitalTutorWithRelations';

export interface ClinicalCaseWithDigitalTutorSurveyCount extends ClinicalCase {
  digitalTutorSurveyCount$: Observable<number>;
}

@Injectable({
  providedIn: 'root',
})
export class DigitalTutorSurveyService {
  constructor(
    private _userDigitalTutorSurveyControllerApi: UserDigitalTutorSurveyControllerApi,
  ) {}

  countDigitalTutorSurveyCompleted(
    academyEduModuleId: string,
    where: {
      [key: string]: unknown;
    },
  ): Observable<number> {
    return this._userDigitalTutorSurveyControllerApi
      .userDigitalTutorSurveyControllerCount(
        academyEduModuleId,
        JSON.stringify(where) as never,
      )
      .pipe(map((response) => response.count));
  }

  clinicalCaseWithUserSurveyCount(
    academyEduModuleId: string,
    clinicalCases: ClinicalCaseDigitalTutorWithRelations[],
  ): ClinicalCaseWithDigitalTutorSurveyCount[] {
    return clinicalCases.map((c: ClinicalCaseWithDigitalTutorSurveyCount) => {
      const where = { clinicalCaseId: c.id };
      c.digitalTutorSurveyCount$ = this.countDigitalTutorSurveyCompleted(
        academyEduModuleId,
        where,
      );
      return c;
    });
  }
}
